module.exports = __webpack_public_path__ + "static/media/logo_en.aca10bf9.png";